import React, { FC, useEffect } from 'react';
import AdhdPortalApp from '../../adhd/adhd-portal-app';
import { captureUtmFromUrl } from '../../adhd/utils/source-tracking';

const AdhdPortal: FC = () => {
  useEffect(() => {
    captureUtmFromUrl(window.location.search);
  }, []);

  return <AdhdPortalApp />;
};

export default AdhdPortal;
